"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _types = require("../types/types.generic");
var _audioVideoHelpers = require("@studio/chime/audioVideo/audioVideoHelpers");
var _Sources = require("@studio/constants/Sources");
var _Vendor = require("@studio/constants/Vendor");
var _broadcastSourcesSelector = require("../../selectors/broadcastSourcesSelector");
var _setAttendeeCameraStatus = _interopRequireDefault(require("./setAttendeeCameraStatus"));
var _cancelDisconnectSource = _interopRequireDefault(require("../source/cancelDisconnectSource"));
var _getSources = _interopRequireDefault(require("../source/getSources"));
var _queueDisconnectSource = _interopRequireDefault(require("../source/queueDisconnectSource"));
var _featureFlags = require("@studio/feature.flags/featureFlags");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * @param {*} attendeeId
 * @param {*} presence
 * @param {*} disconnectSource
 * @returns
 */
function setAttendeePresence(attendeeId, presence, disconnectSource) {
  return function (dispatch, getState) {
    var state = getState();
    var _state$meeting = state.meeting,
      meetingSession = _state$meeting.meetingSession,
      attendeeResponse = _state$meeting.attendeeResponse,
      attendeePresence = state.attendeePresence;
    var attendeePresent = attendeePresence.includes(attendeeId);
    var sources = (0, _broadcastSourcesSelector.selectBroadcastSources)(state);
    var action = {
      type: _types.BROADCAST_SET_ATTENDEE_PRESENCE,
      payload: {
        attendeeId: attendeeId,
        presence: presence
      }
    };
    var useAgora = (0, _featureFlags.shouldHaveFeature)('studio.meetingVendor') === _Vendor.VENDOR_AGORA;
    (0, _reactRedux.batch)(function () {
      if (attendeeSourceExists(sources, attendeeId)) {
        if (presence) {
          var localAttendeeId = attendeeResponse && attendeeResponse.Attendee.AttendeeId;
          // Only execute for other presenters and not screen share sources
          if (localAttendeeId !== attendeeId && !attendeeId.includes('#content') && !useAgora) {
            var isAttendeeCameraOn = (0, _audioVideoHelpers.haveVideoTileForAttendeeId)(meetingSession, attendeeId);
            dispatch((0, _setAttendeeCameraStatus["default"])(attendeeId, isAttendeeCameraOn));
          }
          // If they are present, and they have a source, cancel the disconnect
          forEachAttendeeSource(attendeeId, sources, function (s) {
            dispatch((0, _cancelDisconnectSource["default"])(s._id));
          });
          // We only want to fetch all sources when a new user joins, if attendee is already present skip.
          if (!attendeePresent) {
            dispatch((0, _getSources["default"])());
          }
        } else {
          forEachAttendeeSource(attendeeId, sources, function (s) {
            dispatch((0, _queueDisconnectSource["default"])(s._id, 1, disconnectSource));
          });
        }
      }
      dispatch(action);
    });
  };
}
function isExistingAttendee(s, attendeeId) {
  return s.type === _Sources.CAMERA_PRESENTER && s.value === attendeeId;
}
function forEachAttendeeSource(attendeeId, sources, cb) {
  sources.filter(function (s) {
    return isExistingAttendee(s, attendeeId);
  }).forEach(cb);
}
function attendeeSourceExists(sources, attendeeId) {
  return !!sources.find(function (s) {
    return isExistingAttendee(s, attendeeId);
  });
}
var _default = exports["default"] = setAttendeePresence;